// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Atoms
import Spacer from 'atoms/Spacer'
import NumberInput from 'atoms/NumberInput'
import FieldLayout from '../FieldLayout'

export default class ProposalSeatsEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleSave = (seats) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ seats })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete({ seats: null })
  }

  render() {
    const { proposal } = this.props
    const defaultValue = parseInt(proposal.seats, 10)
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Capacity" onDelete={this.handleDelete}>
          <NumberInput
            required
            minValue={0}
            valueAddon={` ${defaultValue === 1 ? 'participant' : 'participants'}`}
            placeholder="Enter max. number of participants"
            defaultValue={defaultValue}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
